import * as React from 'react';
import { observer } from 'mobx-react';

import { AgentMarketView } from './agent-market.view';
import { AgentMarketDataService } from './agent-market-form.data';

interface Props extends ComponentViewProps<AgentItem> {
	dataService: AgentMarketDataService;
	mode: ControlMode;
}

@observer
export class AgentMarketController extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	handleCreateAgentMarket = async(): Promise<AgentMarketItem> => {
		const { dataService, model } = this.props;
		let market = await dataService.add(model);
		return market;
	};

	render() {
		const { dataService, mode, setBusy } = this.props;
		if (dataService == null || dataService.items == null) {
			return null;
		}

		return (
			<AgentMarketView
				model={dataService}
				onCreateAgentMarket={this.handleCreateAgentMarket}
				mode={mode}
				setBusy={setBusy}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-markets/agent-market.controller.tsx